module.exports = __webpack_public_path__ + "img/75645.ce0a1b16.svg";